import { render, staticRenderFns } from "./Wccpurchasecard.vue?vue&type=template&id=6e38d48c&scoped=true&"
import script from "./Wccpurchasecard.vue?vue&type=script&lang=js&"
export * from "./Wccpurchasecard.vue?vue&type=script&lang=js&"
import style0 from "./Wccpurchasecard.vue?vue&type=style&index=0&id=6e38d48c&lang=scss&scoped=true&"
import style1 from "./Wccpurchasecard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e38d48c",
  null
  
)

export default component.exports